<template>
<div class="chapter">
<div class="inner_page">
<p class="alost"><a id="page_ii"></a><span class="bold">Also by New Academia Publishing</span></p>
<p class="also"><em class="italic">RUSSIAN FUTURISM: A History</em>, by Vladimir Markov</p>
<p class="also"><em class="italic">WORDS IN REVOLUTION: Russian Futurist Manifestoes 1912-1928</em> A. Lawton and H. Eagle, eds., trs.</p>
<p class="also"><em class="italic">MOSCOW BELIEVES IN TEARS: Russians and Their Movies</em>, by Louis Menashe</p>
<p class="also"><em class="italic">IMAGING RUSSIA 2000: Film and Facts</em>, by Anna Lawton</p>
<p class="also"><em class="italic">BEFORE THE FALL: Soviet Cinema in the Gorbachev Years</em>, by Anna Lawton</p>
<p class="also"><em class="italic">WE’RE FROM JAZZ: Festschrift in Honor of Nicholas V. Galichenko</em> Megan Swift and Serhy Yekelchyk, eds.</p>
<p class="also"><em class="italic">NEW PERSPECTIVES ON SOVIETIZATION IN CENTRAL AND EASTERN EUROPE AFTER WORLD WAR II</em>, Balázs Apor, Péter Apor and E. A. Rees, eds.</p>
<p class="also"><em class="italic">THE INNER ADVERSARY: The Struggle against Philistinism as the Moral Mission of the Russian Intelligentsia</em>, by Timo Vihavainen</p>
<p class="also"><em class="italic">RED ATTACK WHITE RESISTANCE</em>, by Peter Kenez</p>
<p class="also"><em class="italic">RED ADVANCE WHITE DEFEAT</em>, by Peter Kenez</p>
<p class="also"><em class="italic">ASPECTS OF BALKAN CULTURE: Social, Political, and Literary Perceptions</em> by Jelena Milojković-Djurić</p>
<p class="also"><em class="italic">SLAVIC THINKERS OR THE CREATION OF POLITIES: Intellectual History and Political Thought in Central Europe and the Balkans in the 19th Century</em> by Josette Baer</p>
<p class="also1"><span class="bold">Fiction</span></p>
<p class="also"><em class="italic">ON THE WAY TO RED SQUARE</em>, by Julieta Almeida Rodrigues</p>
<p class="also1"><span class="bold">Memoirs</span></p>
<p class="also"><em class="italic">THROUGH DARK DAYS AND WHITE NIGHTS: Four Decades Observing a Changing Russia</em>, by Naomi F. Collins</p>
<p class="also"><em class="italic">JOURNEYS THROUGH VANISHING WORLDS</em>, by Abraham Brumberg</p>
<p class="also2"><span class="weblink"><a href="http://www.newacademia.com" target="_blank"><span class="underline">www.newacademia.com</span></a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Also.vue?022a8db5